document.addEventListener('DOMContentLoaded', () => {
	const pageContainer = document.querySelector('#page-content-container');
	const scrollers = document.querySelectorAll('.scroller');
	const nonHomeBodies = document.querySelectorAll('body:not(.home), html');

	if (pageContainer) {
		pageContainer.style.height = 'auto';
	}

	scrollers.forEach(scroller => {
		scroller.style.height = 'auto';
		scroller.style.overflowY = 'auto';
	});

	nonHomeBodies.forEach(body => {
		body.style.height = 'auto';
	});

	const timelineBlocks = document.querySelectorAll('.cd-timeline-block');
	const offset = 0.8;


    // Remove empty <p> tags from the wysiwyg:
    timelineBlocks.forEach(block => {
        const paragraphs = block.querySelectorAll('p');
        paragraphs.forEach(p => {
            if (!p.textContent.trim()) {
                p.remove();
            }
        });
    });

	// Hide timeline blocks initially
	hideBlocks(timelineBlocks, offset);

	// On scroll, show/animate timeline blocks when they enter the viewport
	window.addEventListener('scroll', () => {
		if (!window.requestAnimationFrame) {
			setTimeout(() => {
				showBlocks(timelineBlocks, offset);
			}, 100);
		} else {
			window.requestAnimationFrame(() => {
				showBlocks(timelineBlocks, offset);
			});
		}
	});

	function hideBlocks(blocks, offset) {
		blocks.forEach(block => {
			const blockTop = block.getBoundingClientRect().top + window.scrollY;
			const windowHeight = window.innerHeight;

			if (blockTop > window.scrollY + windowHeight * offset) {
				const imgContent = block.querySelectorAll('.cd-timeline-content-inner');
				imgContent.forEach(el => el.classList.add('is-hidden'));
			}
		});
	}

	function showBlocks(blocks, offset) {
		blocks.forEach(block => {
			const blockTop = block.getBoundingClientRect().top + window.scrollY;
			const windowHeight = window.innerHeight;

			if (blockTop <= window.scrollY + windowHeight * offset) {
				const imgContent = block.querySelectorAll('.cd-timeline-content-inner');
				imgContent.forEach(el => {
					if (el.classList.contains('is-hidden')) {
						el.classList.remove('is-hidden');
						el.classList.add('bounce-in');
					}
				});
			}
		});
	}
});
